var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenChildCollapseIconInModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.405166 7.82501L7.51273 0.713996C7.65711 0.569519 7.80998 0.465833 7.97135 0.402937C8.13269 0.340041 8.30483 0.308593 8.48776 0.308593C8.67067 0.308593 8.8428 0.340041 9.00417 0.402937C9.16551 0.465833 9.31837 0.569519 9.46275 0.713996L16.5948 7.84955C16.8649 8.11982 17 8.44907 17 8.83731C17 9.22554 16.8649 9.5548 16.5948 9.82506C16.3247 10.0953 15.9915 10.2264 15.5953 10.2182C15.1991 10.21 14.8659 10.0708 14.5958 9.80053L8.48776 3.68952L2.35523 9.82506C2.08509 10.0953 1.76008 10.2305 1.3802 10.2305C1.00031 10.2305 0.675302 10.0953 0.405166 9.82506C0.135055 9.55479 -3.86526e-07 9.22146 -3.69335e-07 8.82506C-3.52143e-07 8.42863 0.135055 8.09528 0.405166 7.82501Z",
    fill: "#01A3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenChildCollapseIconInModal);
export default __webpack_public_path__ + "static/media/openChildCollapseIconInModal.b17d2b42.svg";
export { ForwardRef as ReactComponent };